export interface Customer {
    id?: string;
    dba: string;
    firstName: string;
    lastName: string;
    email: string;
    userTypeId: string;
    userTypeRoleId: string;
    isoIdentified: number;
    UserId?: string;
    address1: string;
    address2: string;
    zipcode: string;
    city: string;
    state: string;
    phoneNumber: string;
    techSupportEmail: string;
    techSupportPhoneNumber: string;
    helpDeskEmail: string;
    helpDeskPhone: string;
    defaultUser?: boolean;
    createdBy?: string;
    createdOn?: string;
    ownedBy?: string;
    logo1Index: number,
    logo1Label: string,
    logo1Image: string,
    logo2Index: number,
    logo2Label: string,
    logo2Image: string,
    logo3Index: number,
    logo3Label: string,
    logo3Image: string,
    logo4Index: number,
    logo4Label: string,
    logo4Image: string,
    logo5Index: number,
    logo5Label: string,
    logo5Image: string, 
    createdAt?: string;
    updatedAt?: string;
    user_from_customer?:any;
    priorityId: string;
}

export interface ICustomer {
  consumerId: string;
  cardDetails: string;
  email: string;
  phone?: string | null;
  cardHolderName: string;
  createdAt: string;
  firstName?: string | null;
  lastName?: string | null;
  externalRefId?: string | null;
  dba?: string | null;
  zipCode?: string | null;
  state?: string | null;
  city?: string | null;
  store_to_consumer: StoreToConsumer;
  consumer_from_txextns: ConsumerFromTxextns;
}
export interface StoreToConsumer {
  id: string;
  storeId: string;
  storeFirstName: string;
  storeLastName: string;
  city: string;
}
export interface ConsumerFromTxextns {
  id: string;
  txId: string;
  surveyDetails: string;
  txbase_to_txextns: TxbaseToTxextns;
}
export interface TxbaseToTxextns {
  transactionId: string;
  lastVisitedDate: string;
  noOfVisit: number;
  currencyAmt: number;
  totalAmount: number;
}
export enum Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
export enum ModifiedStatus {
  Added = 'Added',
  Deleted = 'Deleted'
}


